import { http } from '@/core/api/';

const apiUrl = 'api/referralvocationalrehabilitation';
const reportApiUrl = 'api/report';

export const save = (payload) => http.post(apiUrl, payload);
export const get = (id) => http.get(`${apiUrl}/${id}`);
export const search = (params) => http.get(`${apiUrl}/search`, { params });
export const getStatuses = () => http.get(`${apiUrl}/statuses`);
export const changeStatus = (id, payload) =>
  http.post(`${apiUrl}/${id}/status`, payload);
export const returnToDraft = (id) => http.post(`${apiUrl}/${id}/return-draft`);
export const getEligibilityDeterminationConditions = (includeOther = false) =>
  http.get(
    '/api/triannualstudentevaluation/eligibilitydeterminationconditions',
    {
      params: { includeOhter: includeOther },
    }
  );
export const getDocuments = (id) => http.get(`${apiUrl}/${id}/tab/documents`);
export const getDocumentHistory = (id, documentId) =>
  http.get(`${apiUrl}/${id}/tab/documents/${documentId}/history`);
export const saveDocument = (id, payload) =>
  http.post(`${apiUrl}/${id}/tab/documents`, payload);
export const removeDocument = (id, documentId) =>
  http.delete(`${apiUrl}/${id}/tab/documents/${documentId}`);
export const saveSignedDocument = (id, payload) =>
  http.post(`${apiUrl}/${id}/tab/signature/signed-document`, payload);

export const getReport = (id) =>
  http.get(`${reportApiUrl}/referralvocationalrehabilitation/${id}`);
export const getSaee12Report = (id) =>
  http.get(`${reportApiUrl}/saee-12/${id}`);
export const getSaee12bReport = (params) =>
  http.get(`${reportApiUrl}/saee-12b`, { params });
export const getBinnacles = (id, params) =>
  http.get(`${apiUrl}/${id}/tab/binnacle`, { params });
export const addBinnacle = (id, payload) =>
  http.post(`${apiUrl}/${id}/tab/binnacle`, payload);
export const removeBinnacle = (id, binnacleId) =>
  http.delete(`${apiUrl}/${id}/tab/binnacle/${binnacleId}`);
export const sendReferralToArv = (id) => http.post(`${apiUrl}/${id}/send-arv`);
export const cancel = (id, payload) =>
  http.post(`${apiUrl}/${id}/cancel`, payload);
